import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
export const ChevronRightMiniIcon = (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (_jsx("svg", Object.assign({ width: size, height: size }, rest, { viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z', fill: 'currentColor' }) })));
};
//# sourceMappingURL=chevron_right_mini.icon.js.map